import { Action } from '@ngrx/store';


export enum ConfigSceneATypes {
  SCENE_CONFIG_RESET = '[SCENE] Config Reset',
  SCENE_CONFIG_GET = '[SCENE] Config Get',
  SCENE_CONFIG_SUCCESS = '[SCENE] Config Success',
  SCENE_CONFIG_FAILURE = '[SCENE] Config Failure',
}

export class ConfigSceneReset implements Action {
  readonly type = ConfigSceneATypes.SCENE_CONFIG_RESET;
  constructor() {}
}

export class ConfigSceneGet implements Action {
  readonly type = ConfigSceneATypes.SCENE_CONFIG_GET;
  constructor(public IdScene: number) {}
}

export class ConfigSceneSuccess implements Action {
  readonly type = ConfigSceneATypes.SCENE_CONFIG_SUCCESS;
  constructor(public ConfigScene: any) {}
}

export class ConfigSceneFailure implements Action {
  readonly type = ConfigSceneATypes.SCENE_CONFIG_FAILURE;
  constructor(public payload: any) {}
}


export type ConfigSceneAcciones =
  | ConfigSceneReset
  | ConfigSceneGet
  | ConfigSceneSuccess
  | ConfigSceneFailure;